import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { Text } from '@frontend/design-system';
import { styles } from '../panel-feature-promotion-banner.styles';
import type {
  PanelFeaturePromotionBannerBodyProps,
  PanelFeaturePromotionBannerDescriptionProps,
  PanelFeaturePromotionBannerTitleProps,
} from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerBody: FC<PanelFeaturePromotionBannerBodyProps> = ({
  children,
  className,
  testId,
}) => {
  return (
    <section className={cx(styles.body, className)} data-testid={testId}>
      {children}
    </section>
  );
};

export const PanelFeaturePromotionBannerTitle: FC<PanelFeaturePromotionBannerTitleProps> = ({
  children,
  as = 'div',
  className,
  testId,
}) => {
  return (
    <Text as={as} size='medium' weight='bold' className={cx(styles.title, className)} data-testid={testId}>
      {children}
    </Text>
  );
};

export const PanelFeaturePromotionBannerDescription: FC<PanelFeaturePromotionBannerDescriptionProps> = ({
  children,
  as = 'div',
  className,
  testId,
}) => {
  return (
    <Text as={as} size='medium' className={cx(styles.description, className)} data-testid={testId}>
      {children}
    </Text>
  );
};
